import { useState } from "react";

const KEY = "dh_j_pilot_signups";

export default function BrokerPilot() {
  const [form, setForm] = useState({ name: "", email: "", office: "", notes: "" });
  const [saved, setSaved] = useState(false);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function submit(event) {
    event.preventDefault();
    const rows = JSON.parse(localStorage.getItem(KEY) || "[]");
    rows.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem(KEY, JSON.stringify(rows));
    setSaved(true);
  }

  return (
    <article>
      <h1>Broker pilot</h1>
      <p className="lead">
        A small group of offices will walk the full desk — checklists, messaging, archive, and the
        retention log — before wider billing. Tell us the office. We will follow up calmly.
      </p>
      {saved ? (
        <p className="confirm">Thank you. Your interest is saved on this device for now.</p>
      ) : (
        <form className="card" onSubmit={submit} style={{ maxWidth: "32rem" }}>
          <label className="field">
            <span>Name</span>
            <input name="name" value={form.name} onChange={update} required />
          </label>
          <label className="field">
            <span>Email</span>
            <input name="email" type="email" value={form.email} onChange={update} required />
          </label>
          <label className="field">
            <span>Office</span>
            <input name="office" value={form.office} onChange={update} required />
          </label>
          <label className="field">
            <span>Notes</span>
            <textarea name="notes" rows={4} value={form.notes} onChange={update} />
          </label>
          <button className="btn" type="submit">
            Request a conversation
          </button>
        </form>
      )}
    </article>
  );
}
